var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('i',{class:`bi bi-${_vm.icon} fs-2 pt-1 me-3`}),_c('input',{staticClass:"form-control",attrs:{"type":"text","required":_vm.required,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }